// extracted by mini-css-extract-plugin
export default {"pageContainer":"ExploreTheMindPage_pageContainer__pRr1Y","card":"ExploreTheMindPage_card__P0594","react-flow__renderer":"ExploreTheMindPage_react-flow__renderer__sDe9h"};